import React from 'react'
import { List as OrganizationList } from '../../organization/components'
// import OrganizationList from '../../organization/components/paginated-list'
import { List as ProgramList } from '../../program/components'
import { List as EventList } from '../../event/components'
import { List as BlogList } from '../../blog/components'
import { List as ResourceList } from '../../resource/components'
import { Route } from 'react-router-dom'

const AlertEmpty = ({collection}) => {
  return <div className="px-2 lg:px-0">
    <p className="text-lg lg:text-2xl my-8 lg:my-0">Oops, the {collection} items was not found!</p>
  </div>
}

const List = ({ query, data = [] }) => {

  // todo
  // Get data by query
  // Pass into collection's list component

  return (
    <div>
      <Route
        path="/search-results/program"
        render={() => (
          data && data.length > 0 ? (
            <ProgramList data={data} uniform />
          ) : (
            <AlertEmpty collection="program"/>
          )
        )}
      />
      <Route
        path="/search-results/organization"
        render={() => (
          data && data.length > 0 ? (
            <>
              {/* <OrganizationList
                query={query}
                defaultData={data}
              /> */}

              {/* <QueryProvider apiKey="organizations">
                <Test />
              </QueryProvider> */}

              <OrganizationList data={data} />
            </>
          ) : (
            <AlertEmpty collection="organization"/>
          )
        )}
      />
      <Route
        path="/search-results/event"
        render={() => (
          data && data.length > 0 ? (
            <EventList data={data} uniform />
          ) : (
            <AlertEmpty collection="event"/>
          )
        )}
      />
      <Route
        path="/search-results/resource"
        render={() => (
          data && data.length > 0 ? (
            <ResourceList data={data} uniform />
          ) : (
            <AlertEmpty collection="resource"/>
          )
        )}
      />
      <Route
        path="/search-results/blog"
        render={() => (
          data && data.length > 0 ? (
            <BlogList data={data} uniform />
          ) : (
            <AlertEmpty collection="blog"/>
          )
        )}
      />
    </div>
  )
}

export { List }
